/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * External Imports
 */
import { TaskContainer } from './styles/Employee.styles';
import SearchHeader from '../../components/searchHeader';
import StoplightTable from '../../components/customTables/tasks/stoplightTable';

interface StoplightPageProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const EmployeeStoplight: FC<StoplightPageProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  return (
    <TaskContainer id="Employee-Stoplight">
      <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <StoplightTable searchTerm={searchTerm} />
    </TaskContainer>
  );
};

export default EmployeeStoplight;
